import axios from '@/util/request'
//商品管理

// POST /com/had-login/shopp-product/saveShoppProduct
// 商品新增修改
export const saveShoppProduct = (data) => {
    return axios({
      url: '/com/had-login/shopp-product/saveShoppProduct',
      method: 'post',
      data
    })
  }

//   /com/had-login/shopp-product/getShoppProductPage
// 商品列表 管理
export const getShoppProductPage = (data) => {
  return axios({
    url: '/com/had-login/shopp-product/getShoppProductPage',
    method: 'post',
    data
  })
}

// /com/had-login/shopp-product/updateIsShelf
// 商品上架（包含放入回收站和还原）
export const updateIsShelfproduct = (params) => {
  return axios({
    url: '/com/had-login/shopp-product/updateIsShelf',
    method: 'get',
    params
  })
}

// /com/had-login/shopp-product/deleteShoppProduct
// 商品删除
export const deleteShoppProduct = (params) => {
  return axios({
    url: '/com/had-login/shopp-product/deleteShoppProduct',
    method: 'get',
    params
  })
}

// /com/had-login/shopp-product/getShoppProductInfo
// 商品详情
export const getShoppProductInfo = (params) => {
  return axios({
    url: '/com/had-login/shopp-product/getShoppProductInfo',
    method: 'get',
    params
  })
}

// /com/had-login/shopp-product/getRelatedExperts
// 查看已关联专家
export const getRelatedExperts = (params) => {
  return axios({
    url: '/com/had-login/shopp-product/getRelatedExperts',
    method: 'get',
    params
  })
}

// /com/had-login/sys/expert/getExpertList
// 查看专家列表(全部)
export const getExpertList = (data) => {
  return axios({
    url: '/com/had-login/sys/expert/getExpertList',
    method: 'post',
    data
  })
}

// /com/had-login/shopp-product/relatedExperts
// 关联专家
export const relatedExperts = (data) => {
  return axios({
    url: '/com/had-login/shopp-product/relatedExperts',
    method: 'post',
    data
  })
}

//关联专家删除
// /com/had-login/shopp-product/deleteRelatedExperts
// 删除关联专家
export const deleteRelatedExperts = (data) => {
  return axios({
    url: '/com/had-login/shopp-product/deleteRelatedExperts',
    method: 'post',
    data
  })
}

// /com/had-login/shopp-order/saveShoppOrder
// 订单新增修改
export const saveShoppOrder = (data) => {
  return axios({
    url: '/com/had-login/shopp-order/saveShoppOrder',
    method: 'post',
    data
  })
}

// /com/had-login/sys/company/getCompanyList
// 公司列表查询全部
export const getCompanyList = (params) => {
  return axios({
    url: '/com/had-login/sys/company/getCompanyList',
    method: 'get',
    params
  })
}

// /com/had-login/user/page
// 分页查询用户
export const pageuser = (data) => {
  return axios({
    url: '/com/had-login/user/page',
    method: 'post',
    data
  })
}

// /com/had-login/college/school-info/getSchoolInfoList
// 获取列表所有（选择学校）
export const getSchoolInfoList = (data) => {
  return axios({
    url: '/com/had-login/college/school-info/getSchoolInfoList',
    method: 'post',
    data
  })
}

// /com/had-login/shopp-order/getShoppOrderPage
// 订单列表 管理
export const getShoppOrderPage = (data) => {
  return axios({
    url: '/com/had-login/shopp-order/getShoppOrderPage',
    method: 'post',
    data
  })
}

// /com/had-login/shopp-order/deleteShoppOrder
// 订单删除
export const deleteShoppOrder = (params) => {
  return axios({
    url: '/com/had-login/shopp-order/deleteShoppOrder',
    method: 'get',
    params
  })
}

// /com/had-login/shopp-order/cancelOrder
// 取消订单
export const cancelOrder = (params) => {
  return axios({
    url: '/com/had-login/shopp-order/cancelOrder',
    method: 'get',
    params
  })
}

// /com/had-login/shopp-order/refundPrice
// 退款
export const refundPrice = (data,params) => {
  return axios({
    url: '/com/had-login/shopp-order/refundPrice',
    method: 'post',
    data,
    params
  })
}

// /com/had-login/shopp-order/sendOutGoods
// 订单发货
export const sendOutGoods = (data) => {
  return axios({
    url: '/com/had-login/shopp-order/sendOutGoods',
    method: 'post',
    data
  })
}

// /com/had-login/shopp-order/getShoppOrderInfo
// 订单详情
export const getShoppOrderInfo = (params) => {
  return axios({
    url: '/com/had-login/shopp-order/getShoppOrderInfo',
    method: 'get',
    params
  })
}

// /com/had-login/shopp-order/replaceExperts
// 更换专家
export const replaceExperts = (params) => {
  return axios({
    url: '/com/had-login/shopp-order/replaceExperts',
    method: 'get',
    params
  })
}

// /com/had-login/shopp-order/refundPriceList
// 价格变更记录
export const refundPriceList = (params) => {
  return axios({
    url: '/com/had-login/shopp-order/refundPriceList',
    method: 'get',
    params
  })
}

// /com/had-login/shopp-order/placeOrder
// 订单下单
export const placeOrder = (data) => {
  return axios({
    url: '/com/had-login/shopp-order/placeOrder',
    method: 'post',
    data
  })
}

// /com/had-login/shopp-order/perfectInformation
// 订单完善信息
export const perfectInformation = (data) => {
  return axios({
    url: '/com/had-login/shopp-order/perfectInformation',
    method: 'post',
    data
  })
}

export const payment = (data) => {
  return axios({
    url: '/com/had-login/shopp-order/payment',
    method: 'post',
    data
  })
}

export const updateStudent = (data) => {
  return axios({
    url: '/com/had-login/shopp-order/updateStudent',
    method: 'post',
    data
  })
}

// 修改专家价格
// /com/had-login/shopp-product/updateRelatedExperts
export const updateRelatedExperts = (data) => {
  return axios({
    url: '/com/had-login/shopp-product/updateRelatedExperts',
    method: 'post',
    data
  })
}

// /com/had-login/shopp-product/updateIsShow
export const updateIsShow = (params) => {
  return axios({
    url: '/com/had-login/shopp-product/updateIsShow',
    method: 'get',
    params
  })
}

// /com/had-login/shopp-order/updateRemark
export const updateRemark = (data) => {
  return axios({
    url: '/com/had-login/shopp-order/updateRemark',
    method: 'post',
    data
  })
}

//修改订单username  com/had-login/shopp-order/updateUserName
export const updateOrderUsername = (params) => {
  return axios({
    url: '/com/had-login/shopp-order/updateUserName',
    method: 'get',
    params
  })
}

//GET /com/had-login/shopp-product/updateShowSort
//修改产品显示排序
export const changeProductShowSort = (params) => {
  return axios({
    url: '/com/had-login/shopp-product/updateShowSort',
    method: 'get',
    params
  })
}

//GET /com/had-login/shopp-product/updateStatisticsSort
//修改产品统计排序
export const changeProductStatisticsSort = (params) => {
  return axios({
    url: '/com/had-login/shopp-product/updateStatisticsSort',
    method: 'get',
    params
  })
}

/**
 * 保存订单备注
 * @param data
 * @returns {*}
 */
export  const saveShopOrderRemark = (data) => {
  return axios({
    url: '/com/had-login/shopp/shop-order-remark/saveShopOrderRemark',
    method: 'post',
    data
  })
}

/**
 * 删除备注
 * @param params
 * @returns {*}
 */
export  const deleteShopOrderRemark = (params) => {
  return axios({
    url: '/com/had-login/shopp/shop-order-remark/deleteShopOrderRemark',
    method: 'get',
    params
  })
}

/**
 * 获取订单备注列表
 * @param params
 * @returns {*}
 */
export  const getShopOrderRemarkList = (params) => {
  return axios({
    url: '/com/had-login/shopp/shop-order-remark/getShopOrderRemarkList',
    method: 'get',
    params
  })
}
